import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { AppContext } from '../../../app-config';
import { DebugTrayComponent } from '../../debug/debug-tray.component';

@Component({
  selector: 'app-footer',
  imports: [NgClass, DebugTrayComponent],
  templateUrl: './footer.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit, OnDestroy {
  @AppContext() private _appContext!: AppContext;
  private router = inject(Router);
  private routerSubscription: Subscription = new Subscription();

  protected readonly currentYear: number = new Date().getFullYear();
  public showDebugTray = false;
  public notProd = this._appContext.notProd;
  public isComparePage = signal(false);
  public isComingSoonPage = signal(false);

  ngOnInit() {
    this.routerSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.isComparePage.set(this.router.url.includes('/quote/compare'));
      this.isComingSoonPage.set(this.router.url.includes('/thanks/coming-soon'));
    });
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  public toggleDebugTray() {
    this.showDebugTray = !this.showDebugTray;
  }
}
